import { CSSProperties, ReactNode, useMemo } from 'react'
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'
import './Loader.scss'

export function Loader(props: {
  blocking?: boolean
  children?: ReactNode
  renderChildren?: boolean
  style?: CSSProperties
  className?: string
}) {
  const className = useMemo(() => {
    const classes: string[] = ['loader-container']
    if (props.blocking) classes.push('blocking')
    if (props.className) classes.push(props.className)
    return classes.join(' ')
  }, [props.blocking, props.className])

  return (
    <div className={className} style={props.style}>
      {!props.blocking || props.renderChildren !== false ? props.children : undefined}
      {props.blocking && (
        <div className="loader-overlay-container">
          <div className="loader-overlay"></div>
          <div className="loader-message-container">
            <div className="loader-message">
              <LoadingSpinner />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
